// src/pages/Home.js
import '../styles/Home.css';
import { Link } from 'react-router-dom';

import logo from '../assets/images/Q3LOGO_notext.png';
import tlvec from '../assets/images/topleftvec.png';
import trvec from '../assets/images/toprightvec.png';
import rvec  from '../assets/images/rightvec.png';
import lvec  from '../assets/images/leftvec.png';

import cqn from '../assets/images/sponsor-logos/cqnlogo.png';
import itu from '../assets/images/sponsor-logos/ITU_logo.png';
import mqa from '../assets/images/sponsor-logos/mqa_logo.jpg';
import qsf from '../assets/images/sponsor-logos/umd_qsf_logo.png';
import unitary from '../assets/images/sponsor-logos/UFoundation.png';
import qv from '../assets/images/sponsor-logos/QV ICON.png';
import ece from '../assets/images/sponsor-logos/eceumd.png';
import artsforall from '../assets/images/sponsor-logos/artsforallumd.jpg';
import wiser from '../assets/images/sponsor-logos/wiser.png';

function Home() {
  const slides = [
    { src: cqn,     alt: 'Center for Quantum Networks', external: 'https://cqn-erc.org/' },
    { src: itu,     alt: 'UN International Telecommunication Union', external: 'https://www.itu.int/' },
    { src: ece,     alt: 'UMD Electrical & Computer Engineering Department', external: 'https://ece.umd.edu/' },
    { src: qv,      alt: 'Quantum Village', external: 'https://quantumvillage.org/' },
    { src: artsforall, alt: 'Arts for All', external: 'https://arts.umd.edu/' },
    { src: wiser,   alt: 'Wiser', external: 'https://www.thewiser.org/' },
    { src: unitary, alt: 'Unitary Foundation', external: 'https://unitary.fund/' },
    { src: mqa,     alt: 'Mid-Atlantic Quantum Alliance', external: 'https://midatlanticquantum.org/' },
    { src: qsf,     alt: 'Quantum Startup Foundry', external: 'https://qsf.umd.edu/' },
  ];

  // shared style helpers to keep this self-contained (no CSS edits required)
  const bgLayer = {
    position: 'absolute',
    inset: 0,
    pointerEvents: 'none',
    zIndex: 0,
    overflow: 'hidden',
  };
  const cap = 'min(35vw, 700px)'; // tweak this to grow/shrink the corner art

  const imgTL = { position: 'absolute', top: 0, left: 0,  maxWidth: cap, height: 'auto' };
  const imgTR = { position: 'absolute', top: 0, right: 0, maxWidth: cap, height: 'auto' };
  const imgBL = { position: 'absolute', bottom: 0, left: 0, maxWidth: cap, height: 'auto' };
  const imgBR = { position: 'absolute', bottom: 0, right: 0, maxWidth: cap, height: 'auto' };

  return (
    <div className="Home" style={{ position: 'relative', minHeight: '100%', overflow: 'hidden' }}>
      {/* Background layers (separated so top/bottom never overlap content or each other) */}
      <div aria-hidden style={bgLayer}>
        <img src={tlvec} alt="" style={imgTL} />
        <img src={trvec} alt="" style={imgTR} />
      </div>
      <div aria-hidden style={bgLayer}>
        <img src={lvec}  alt="" style={imgBL} />
        <img src={rvec}  alt="" style={imgBR} />
      </div>

      {/* Foreground content */}
      <div style={{ position: 'relative', zIndex: 1 }}>
        <img src={logo} className="logo-img" alt="Q^3 Logo" />

        {/* NOTE: move favicon to public/index.html (inside <head>) instead of here */}

        <div className="home-content">
          <h1 className="page-title">
            Q<sup>3</sup> Initiative
          </h1>

          <p style={{ fontSize: '2rem', padding: '0rem 1rem 2rem', color: '#2079AF' }}>
            September 12 - 14, 2025
          </p>

          <h2 style={{ fontSize: '3.5rem', padding: '1rem 0rem 1rem', color: '#2079AF' }}>
            About Q<sup>3</sup>
          </h2>

          <p>
            A joint Center for Quantum Networks and United Nations International Telecommunications Union quantum
            initiative dedicated to three pillars: art, ethics, and engineering. With two host institutions, the
            University of Maryland and the University of California, this quantum initiative will span from coast to
            coast. The Q<sup>3</sup> Initiative has two core goals: (1) to foster collaboration between artists and
            scientists to make quantum science more accessible to the general public and (2) to train the general public
            on the fundamentals of quantum computing championing quantum for good.
          </p>

          <h2 style={{ fontSize: '3.5rem', padding: '2rem 0rem 1rem', color: '#2079AF' }}>The Pillars</h2>

          <div className="pillars">
            <Link to="/Qreate" className="pillar">
              <h2 style={{ fontSize: '3rem', padding: '0rem 0rem 1rem', color: '#2079AF' }}>UMD</h2>
              <p>
                A non-traditional, creative-style hackathon with art exhibitions, creative workshops, and non-technical
                challenges open for 4 weeks.
              </p>
            </Link>

            <Link to="/QEthics" className="pillar">
              <h2 style={{ fontSize: '3rem', padding: '0rem 0rem 1rem', color: '#2079AF' }}>USC</h2>
              <p>
                A traditional, 24-hour technical quantum hackathon and gather insight on real world applications of
                quantum engineering.
              </p>
            </Link>

            <div className="sponsors">
              <h1 style={{ fontSize: '4rem', padding: '0rem 0rem 1rem', color: '#2079AF' }}>Partners</h1>
              <p>
                Q<sup>3</sup> would not have been possible without our generous partners! If you are interested in
                sponsoring or partnering with us, please contact hello@q3initiative.org
              </p>

              <section className="sponsors-slider">
                <div className="slider-nav slider-nav-grid">
                  {slides.map(({ src, alt, external }) => (
                    <div className="slider-nav-slide" key={alt}>
                      {external ? (
                        <a href={external} target="_blank" rel="noopener noreferrer">
                          <img src={src} alt={alt} className="slide-img" />
                        </a>
                      ) : (
                        <img src={src} alt={alt} className="slide-img" />
                      )}
                    </div>
                  ))}
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
